module.exports = __webpack_public_path__ + "img/file.a29c7124.svg";